import Box from '@mui/joy/Box'
import Typography from '@mui/joy/Typography'
import type { PromoPageContent } from '@numeo/types-main-mobile'
import { PROMO_PAGE_ICON_COMPONENTS } from './promoPageIcons'

// The app's promo page palette (mobile `theme/colors.ts`, PROMO_PAGE_COLORS): dark in both schemes.
const CANVAS = 'linear-gradient(180deg, #000000 10%, #131C7A 78%)'
const PANEL = 'rgba(4, 133, 247, 0.15)'
const ACCENT = '#0485F7'
const CONTROL = '#29292D'

/** Phone-frame preview of the draft, as the app draws it (Figma Spot 10447:108069). */
export function PromoPagePreview({ page }: { page: Partial<PromoPageContent> }) {
    return (
        <Box sx={{ width: 300, height: 620, borderRadius: '40px', border: '10px solid #1E293B', overflow: 'hidden', position: 'relative', background: CANVAS }}>
            <Box sx={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', px: 1.5, pt: 5, pb: 1.5, color: '#FFFFFF' }}>
                <Box
                    sx={{
                        width: 28,
                        height: 28,
                        borderRadius: '50%',
                        bgcolor: CONTROL,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 12,
                    }}
                >
                    ✕
                </Box>
                <Box sx={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 1, pt: 2 }}>
                    {page.logoImageUrl ? (
                        <Box component="img" src={page.logoImageUrl} alt="" sx={{ height: 35, alignSelf: 'center', objectFit: 'contain', maxWidth: '100%' }} />
                    ) : null}
                    <Typography sx={{ color: '#FFFFFF', fontSize: 26, fontWeight: 600, lineHeight: 1.12, textAlign: 'center' }}>
                        {page.heading || 'Heading'}
                    </Typography>
                    <Typography sx={{ color: '#FFFFFF', fontSize: 11, textAlign: 'center', px: 2 }}>{page.subheading || 'Subheading'}</Typography>
                    <Box sx={{ mt: 2, bgcolor: PANEL, borderRadius: '18px', p: 1.75, display: 'flex', flexDirection: 'column', gap: 1.75 }}>
                        {(page.features ?? []).map((feature, i) => {
                            const Icon = PROMO_PAGE_ICON_COMPONENTS[feature.icon]
                            return (
                                <Box key={i} sx={{ display: 'flex', gap: 0.75, alignItems: 'flex-start' }}>
                                    <Box
                                        sx={{
                                            width: 28,
                                            height: 28,
                                            flexShrink: 0,
                                            borderRadius: '50%',
                                            bgcolor: '#FFFFFF',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        {Icon ? <Icon size={13} color={ACCENT} /> : null}
                                    </Box>
                                    <Box>
                                        <Typography sx={{ color: '#FFFFFF', fontSize: 11, fontWeight: 500 }}>{feature.title || 'Title'}</Typography>
                                        <Typography sx={{ color: '#FFFFFF', fontSize: 9.5 }}>{feature.subtitle || 'Subtitle'}</Typography>
                                    </Box>
                                </Box>
                            )
                        })}
                    </Box>
                </Box>
                <Box
                    sx={{
                        height: 38,
                        borderRadius: '19px',
                        bgcolor: ACCENT,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 13,
                        fontWeight: 500,
                    }}
                >
                    {page.ctaLabel || 'Button'}
                </Box>
            </Box>
        </Box>
    )
}
